import { render, staticRenderFns } from "./OfferTotals.vue?vue&type=template&id=635593f0&scoped=true&"
import script from "./OfferTotals.vue?vue&type=script&lang=js&"
export * from "./OfferTotals.vue?vue&type=script&lang=js&"
import style0 from "./OfferTotals.vue?vue&type=style&index=0&id=635593f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635593f0",
  null
  
)

export default component.exports